import { Map } from "@/shared/components/control";
import type { PrivacySection } from "@/config/site";
import { site } from "@/config/site";
import { PublicPageLayout } from "@/shared/components/layout/public-page-layout";
import { Section, TextLink } from "@/shared/components/ui";
import { useTranslation } from "react-i18next";

export function PrivacyPage() {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true }) as PrivacySection[];

  return (
    <PublicPageLayout>
      <header className="border-b border-border-soft bg-canvas/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
          <TextLink to={site.links.homePath} className="normal-case tracking-[0.12em]">
            {t("privacy.backLinkLabel")}
          </TextLink>
          <span className="font-mono text-[0.65rem] uppercase tracking-widest text-ink-muted">
            {t("privacy.headerBadge")}
          </span>
        </div>
      </header>
      <main>
        <Section narrow className="pb-24">
          <h1 className="font-display text-3xl font-semibold tracking-tight text-ink">
            {t("privacy.title")}
          </h1>
          <p className="mt-4 text-sm font-normal leading-relaxed text-ink-secondary">
            {t("privacy.lastUpdatedPrefix")}{" "}
            {site.domain.replace("https://", "").replace("http://", "")}.
          </p>

          <div className="mt-10 space-y-8 text-pretty text-sm font-normal leading-relaxed text-ink-secondary">
            <Map
              items={sections}
              keyExtractor={sec => sec.title}
              render={sec => (
                <section>
                  <h2 className="font-display text-lg font-semibold text-ink">
                    {sec.title}
                  </h2>
                  <p className="mt-3">{sec.body}</p>
                </section>
              )}
            />
          </div>
        </Section>
      </main>
    </PublicPageLayout>
  );
}
